module.exports = __webpack_public_path__ + "media/hph-25-09_academic-excellence.cff9be64.mp4";